const BUILD_TIME_API_URL = process.env.VUE_APP_API_URL;
const BUILD_TIME_API_HOST = process.env.VUE_APP_API_HOST;
const BUILD_TIME_PUSHER_APP_KEY = process.env.VUE_APP_PUSHER_APP_KEY;
const BUILD_TIME_PUSHER_HOST = process.env.VUE_APP_PUSHER_HOST;
const BUILD_TIME_PUSHER_PORT = process.env.VUE_APP_PUSHER_PORT ? Number(process.env.VUE_APP_PUSHER_PORT) : 443;
const BUILD_TIME_PUSHER_APP_CLUSTER = process.env.VUE_APP_PUSHER_APP_CLUSTER;

let _apiUrl = BUILD_TIME_API_URL;
let _apiHost = BUILD_TIME_API_HOST || BUILD_TIME_API_URL;
let _pusherAppKey = BUILD_TIME_PUSHER_APP_KEY || "app-key";
let _pusherHost = BUILD_TIME_PUSHER_HOST;
let _pusherPort = BUILD_TIME_PUSHER_PORT;
let _pusherAppCluster = BUILD_TIME_PUSHER_APP_CLUSTER || "";

export const API_ERROR_MESSAGE = "Ошибка выполнения";

export const SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART = process.env.VUE_APP_SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART
  ? process.env.VUE_APP_SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART === "true"
  : true;
export const SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART = process.env
  .VUE_APP_SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART
  ? process.env.VUE_APP_SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART === "true"
  : true;

export const VUE_APP_SHOW_ALL_METRICS_IKP = process.env.VUE_APP_SHOW_ALL_METRICS_IKP
  ? process.env.VUE_APP_SHOW_ALL_METRICS_IKP === "true"
  : true;

export const VUE_APP_COVIDER_LINK = process.env.VUE_APP_COVIDER_LINK || "https://covider.domain.ru";

export const VUE_APP_FAKE_DOCUMENT_AUTHOR = process.env.VUE_APP_FAKE_DOCUMENT_AUTHOR || false;

export const VUE_APP_V3_HOST = process.env.VUE_APP_V3_HOST || "https://doctor-v3.healthkeeper.ru";

export const VUE_APP_BRANDING_LOGO = process.env.VUE_APP_BRANDING_LOGO || "branding/logo-default.svg";
export const VUE_APP_BRANDING_TITLE = process.env.VUE_APP_BRANDING_TITLE || "Кабинет";
export const VUE_APP_BRANDING_FAVICON = process.env.VUE_APP_BRANDING_FAVICON || "/branding/favicon-default.ico";
export const VUE_APP_BRANDING_PRINT_HEADER = process.env.VUE_APP_BRANDING_PRINT_HEADER || "";
export const VUE_APP_BRANDING_PRINT_FOOTER = process.env.VUE_APP_BRANDING_PRINT_FOOTER || "";

const brandingState = {
  logo: VUE_APP_BRANDING_LOGO,
  favicon: VUE_APP_BRANDING_FAVICON,
  title: VUE_APP_BRANDING_TITLE,
  printHeader: VUE_APP_BRANDING_PRINT_HEADER,
  printFooter: VUE_APP_BRANDING_PRINT_FOOTER,
};

export function setBrandingConfig(branding) {
  if (branding.logo !== undefined) brandingState.logo = branding.logo;
  if (branding.favicon !== undefined) brandingState.favicon = branding.favicon;
  if (branding.title !== undefined) brandingState.title = branding.title;
  if (branding.printHeader !== undefined) brandingState.printHeader = branding.printHeader;
  if (branding.printFooter !== undefined) brandingState.printFooter = branding.printFooter;
}

export function getBrandingConfig() {
  return brandingState;
}

export function setApiConfig(api) {
  if (api.url !== undefined) _apiUrl = api.url;
  if (api.host !== undefined) _apiHost = api.host;
}

export function getApiConfig() {
  return {
    url: _apiUrl,
    host: _apiHost,
  };
}

export function setPusherConfig(pusher) {
  if (pusher.appKey !== undefined) _pusherAppKey = pusher.appKey;
  if (pusher.host !== undefined) _pusherHost = pusher.host;
  if (pusher.port !== undefined) _pusherPort = pusher.port;
  if (pusher.cluster !== undefined) _pusherAppCluster = pusher.cluster;
}

export function getPusherConfig() {
  return {
    appKey: _pusherAppKey,
    host: _pusherHost,
    port: _pusherPort,
    cluster: _pusherAppCluster,
  };
}

export {
  _apiUrl as API_URL,
  _apiHost as API_HOST,
  _pusherAppKey as PUSHER_APP_KEY,
  _pusherHost as PUSHER_HOST,
  _pusherPort as PUSHER_PORT,
  _pusherAppCluster as PUSHER_APP_CLUSTER,
};

export default {
  get API_URL() {
    return _apiUrl;
  },
  get API_HOST() {
    return _apiHost;
  },
  API_ERROR_MESSAGE,
  SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART,
  SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART,
  VUE_APP_SHOW_ALL_METRICS_IKP,
  VUE_APP_COVIDER_LINK,
  VUE_APP_V3_HOST,
  VUE_APP_BRANDING_LOGO,
  VUE_APP_BRANDING_TITLE,
  VUE_APP_BRANDING_PRINT_HEADER,
  VUE_APP_BRANDING_PRINT_FOOTER,
  VUE_APP_FAKE_DOCUMENT_AUTHOR,
  getBrandingConfig,
  setBrandingConfig,
  getApiConfig,
  setApiConfig,
  getPusherConfig,
  setPusherConfig,
};
